import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import {Button} from "@mui/material";
import {useEffect, useRef, useState} from "react";
import {ArrowDownward, CheckCircle} from "@mui/icons-material";
import Box from "@mui/material/Box";
import NotifyMinimumPicture from "./NotifyMinimumPicture";
import UploadPicture from "../common/picture/UploadPicture";
import isNull from "../../../../../../mixin/isNull";
import useAlert from "../../../../../../use/useAlert";
import useQualityInspectionRepository from "../../../../../../repository/emergency/useQualityInspectionRepository";
import QualityInspection from "../../../../../../entity/emergency/QualityInspection";
import PopperWrapper from "../../../../../../material/popper/PopperWrapper";
import useEventDispatcher from "../../../../../../use/useEventDispatcher";
import parameter from "../../../../../../enum/parameter";

const ERROR_PICTURE_REQUIRED = "Merci de prendre 2 photos.";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const alert = useAlert();
    const eventDispatcher = useEventDispatcher();
    const qualityInspectionRepository = useQualityInspectionRepository();
    const [loading, setLoading] = useState(false);
    const [pictures, setPictures] = useState(null);
    const nextButtonRef = useRef();

    useEffect(() => {
        if (!isNull(pictures) && pictures.length >= 2) {
            eventDispatcher.launcher("next-step-available");
        }
    }, [pictures?.length]);

    const nextStep = async () => {
        setLoading(true);

        if (isNull(pictures) || pictures.length < 2) {
            alert.warning(ERROR_PICTURE_REQUIRED);
            setLoading(false);
            return;
        }

        const res = await qualityInspectionRepository.update(qualityInspectionId, "current_step", {
            quality_inspection: {
                current_step: QualityInspection.STEP_PICTURE_BEFORE
            },
            uploaded_file: {
                quality_inspection_picture_before_files: pictures
            },
        })

        if (!res) setLoading(false);
    }


    return (
        <>
            <Body>
                <Box mt={2}>
                    <NotifyMinimumPicture/>
                </Box>
                <Box mt={5}>
                    <UploadPicture onChange={setPictures}/>
                </Box>
            </Body>
            <Footer>
                <PopperWrapper
                    elementRef={nextButtonRef}
                    placement={"bottom"}
                    content={"Vous pouvez passer à l'étape suivante"}
                    triggeringEvent={"next-step-available"}
                    autoCloseAfter={parameter.POPUP_TIME}
                    displayCloseButton={false}
                    contentColor={parameter.POPUP_COLOR}
                    icon={<ArrowDownward color={parameter.POPUP_COLOR}/>}
                />
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading || isNull(pictures) || pictures.length < 2}
                    ref={nextButtonRef}
                    data-test="button-next-step"
                >
                    Suivant
                </Button>
            </Footer>
        </>
    )
}